
import { Vue, Component, Prop } from "vue-property-decorator";
import Modal from "./";

@Component({
  name: "LoginModal"
})
export default class LoginModal extends Vue {
  visible: boolean = false;
  text: string = "";
  type: string = "success";
  size: string = "sm";
  beforeMount() {
    Modal.event.$on("show", this.show);
  }

  get buttonClass() {
    var btn = "btn-success";
    if (this.type) {
      switch (this.type.toLowerCase()) {
        case "error":
          btn = "btn-danger";
          break;
        case "warning":
          btn = "btn-warning";
          break;
        default:
          btn = "btn-success";
          break;
      }
    }

    return `btn ${btn} custom-btn-circle custom-btn-md mt-3`;
  }
  get iconClass() {
    var icon = "fa-check";
    if (this.type) {
      switch (this.type.toLowerCase()) {
        case "error":
          icon = "fa-exclamation";
          break;
        case "warning":
          icon = "fa-warning";
          break;
        default:
          icon = "fa-check";
          break;
      }
    }
    return `fa ${icon}`;
  }

  show(text: string, type: string, size: string = "sm") {
    this.text = text;
    this.type = type;
    this.visible = true;
    this.size = size;

    setTimeout(() => (this.visible = false), 5000);
  }
}
